import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data?.token);
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setToken(data?.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setToken(null);
    setUser(false);
  };

  const toggleSave = useCallback(async (pid) => {
    const saved = user?.saved || [];
    const has = saved.includes(pid);
    const { data } = has ? await api.delete(`/wishlist/${pid}`) : await api.post(`/wishlist/${pid}`);
    setUser((u) => (u ? { ...u, saved: data?.saved || [] } : u));
    return !has;
  }, [user]);

  return (
    <AuthCtx.Provider value={{ user, login, register, logout, toggleSave }}>{children}</AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
